// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { EditorState, Modifier } from "draft-js";
import { Button, Label, Input } from "../../../revvComponents";

// Actions Imports
import {
  updateDocumentClickedComponentID,
  // updateComponentEditorState,
  updateComponentMeta,
} from "../../../actions/DocumentActions/index";
import { initActiveEditor } from "../../../actions/EditorActions/editorActions";

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Utils import
import { DocumentUtils } from "../../../utils";
import {
  getComponentData,
  getComponentEditorData,
} from "../../../utils/components";

// Destructure
const { handleHyperlink, getUpdatedParentComponent } = DocumentUtils;
const { DOCUMENT_HYPERLINK_BOX, FONT_COLOR_OPTIONS } = DOCUMENTS;

class HyperlinkBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      urlValue: "",
      wrongURL: false,
      editorState: null,
      confirm: false,
      isUrlPresent: false,
    };
  }

  componentDidMount() {
    const { editorState } = this.props;
    this.setState({ editorState });
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      const contentState = editorState.getCurrentContent();
      const startKey = editorState.getSelection().getStartKey();
      const startOffset = editorState.getSelection().getStartOffset();
      const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
      const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

      let url = "";
      if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        // eslint-disable-next-line prefer-destructuring
        url = linkInstance.getData().url;
      }
      if (url) {
        this.setState({
          isUrlPresent: true,
          urlValue: url,
        });
      }
    }
  }

  _onClose = () => {
    this.props.closeHyperlinkBox();
  };

  _handleChange = e => {
    this.setState({ urlValue: e.target.value });
    // eslint-disable-next-line no-useless-escape
    const re =
      /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]{0,1}/;
    const urlstatus = re.test(e.target.value);
    if (urlstatus) {
      this.setState({ wrongURL: false, confirm: true });
    } else if (!urlstatus) {
      this.setState({ wrongURL: true, confirm: false });
    }
  };

  _onConfirmation = () => {
    let url = this.state.urlValue;
    const { editorState } = this.state;
    if (url && url.length > 0) {
      if (url.substring(0, 4) !== "http") {
        this.setState({
          urlValue: `http://${url}`,
        });
        url = `http://${url}`;
      }
      let nextEditorState;
      let newEditorState;
      const currentFocus = editorState.getSelection().getFocusKey();
      const inlineStyle = editorState.getCurrentInlineStyle(currentFocus);
      if (inlineStyle.size > 0) {
        const nextContentState = Object.keys(FONT_COLOR_OPTIONS).reduce(
          (contentState, color) =>
            Modifier.removeInlineStyle(
              contentState,
              editorState.getSelection(),
              color,
            ),
          editorState.getCurrentContent(),
        );
        nextEditorState = EditorState.push(
          editorState,
          nextContentState,
          "change-inline-style",
        );
        newEditorState = handleHyperlink(nextEditorState, url);
      } else {
        newEditorState = handleHyperlink(editorState, url);
      }
      this._handleNewState(newEditorState);
      const { section, activeComponentMeta } = this.props;
      console.debug("---1--section---1--", section);
      const clickedComponentID =
        section.type === "Table" ? activeComponentMeta.tableCellId : section.id;
      this.props.updateDocumentClickedComponentID(
        clickedComponentID,
        true,
        section.type,
      );
      // this.props.updateComponentEditorState({
      //   componentMeta: this.props.activeComponentMeta,
      //   editorState: newEditorState,
      //   mode: this.props.mode,
      // });
      this.props.initActiveEditor(
        newEditorState,
        section,
        this.props.activeComponentMeta,
      );
      this.props.updateComponentMeta(this.props.activeComponentMeta);
      this._onClose();
    } else {
      this.setState({
        wrongURL: true,
      });
    }
  };

  _updateNewState = (mode, editorState, section) => {
    const newSection = {
      ...section,
      data: editorState.getCurrentContent(),
    };

    // get header of the current content
    const firstBlock = editorState.getCurrentContent().getFirstBlock();
    newSection.header = firstBlock.getText().trim();
    if (firstBlock.getType().startsWith("header")) {
      newSection.label = firstBlock.getText().trim();
    }

    return newSection;
  };

  _handleNewState = editorState => {
    const { section, updateSection, activeComponentMeta } = this.props;
    // check if there is any change in the section or not
    const change = !(section.data === editorState.getCurrentContent());

    // get text/ cell data
    const editorData = getComponentEditorData(
      this.props.components,
      activeComponentMeta,
    );

    editorData.data = editorState.getCurrentContent();

    // get updated component
    const updatedSection = getUpdatedParentComponent(
      this.props.components,
      activeComponentMeta,
      editorData,
    );

    const oldSection = getComponentData(
      this.props.components,
      activeComponentMeta,
    );
    updateSection(updatedSection, change, false, oldSection.content);
  };

  render() {
    const {
      newUrlHeader,
      changeUrlHeader,
      urlInputLabel,
      cancelBtnText,
      insertLinkText,
      modifyLinkText,
    } = DOCUMENT_HYPERLINK_BOX;
    return (
      <Modal open onClose={this._onClose} center closeOnOverlayClick={false}>
        <div>
          {this.state.isUrlPresent ? (
            <div className="createdoc-title">{changeUrlHeader}</div>
          ) : (
            <div className="createdoc-title">{newUrlHeader}</div>
          )}
          <div>
            <Label>
              <span>{urlInputLabel}</span>
            </Label>
            <span>
              <Input
                autoFocus
                id="addlink-input"
                data-test="hyperlink-input-box"
                type="url"
                placeholder="eg. https://www.google.com"
                onChange={e => this._handleChange(e)}
                value={this.state.urlValue}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    // Set a delay to update editorState change in redux before calling _onConfirmation
                    setTimeout(() => this._onConfirmation(), 100);
                  }
                }}
                // ref={this.textInput}
              />
            </span>
            {this.state.wrongURL ? (
              <p className="empty-url-input-box">
                <small>Please Enter a valid link</small>
              </p>
            ) : null}
          </div>
          <br />
          <div className="quote-footer">
            <div className="quote-popup-response">
              <Button
                className="btn-transparent"
                data-test="hyperlink-cancel-btn"
                onClick={this._onClose}>
                {cancelBtnText || "No, I do not want to"}
              </Button>
              <Button
                data-test="hyperlink-add-modify-btn"
                disabled={!this.state.confirm}
                onClick={this._onConfirmation}>
                {!this.state.isUrlPresent ? insertLinkText : modifyLinkText}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { components } = state.DocumentStore;

  return {
    components,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
  updateComponentMeta,
  // updateComponentEditorState,
  initActiveEditor,
};

export default connect(mapStateToProps, mapDispatchToProps)(HyperlinkBox);
